declare global {
  interface Window {
    __ASM_CONFIG__?: {
      API_URL?: string;
    };
  }
}

/** API-URL: Runtime (config.js / Server-.env) vor Build-Zeit (REACT_APP_API_URL). */
export const resolveApiBaseUrl = (): string => {
  const runtime = typeof window !== 'undefined'
    ? window.__ASM_CONFIG__?.API_URL?.trim()
    : undefined;
  const fromEnv = process.env.REACT_APP_API_URL?.trim();
  const raw = runtime || fromEnv || 'https://api.as-monitor.ch';
  return raw.replace(/\/$/, '');
};

// API Configuration
export const API_CONFIG = {
  get BASE_URL(): string {
    return resolveApiBaseUrl();
  },
  
  // API Endpoints
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/db/auth/login',
    LOGIN_FINAL: '/db/auth/login-final',
    LOGOUT: '/db/auth/logout',
    REFRESH: '/db/auth/refresh',
    TOUR_STATUS: (userID: number) => `/auth/tour-status/${userID}`,
    TOUR_COMPLETED: '/auth/tour-completed',
    
    // Operations endpoints
    OPERATIONS_ACTIVE: '/api/v1/operations/active',
    OPERATIONS_ADD: '/api/v1/operations/add',
    OPERATIONS_UPDATE: (id: number) => `/api/v1/operations/${id}`,
    OPERATIONS_CLOSE: '/api/v1/operations/close',
    OPERATIONS_TYPES: '/api/v1/operations/types',
    OPERATIONS_TYPES_ADD: '/api/v1/operations/types/add',
    OPERATIONS_TYPES_BY_ORG: '/api/v1/operations/types/by-org',
    OPERATIONS_TYPES_ALL: '/api/v1/operations/types/all',
    OPERATIONS_TYPES_ADD_TO_ORG: '/api/v1/operations/types/add-to-org',
    OPERATIONS_TYPES_REMOVE_FROM_ORG: '/api/v1/operations/types/remove-from-org',
    OPERATIONS_BY_YEAR: (year: number) => `/api/v1/operations/${year}`,
    
    // Locations endpoints
    LOCATIONS: '/api/v1/locations',
    LOCATIONS_ADD: '/api/v1/locations/add',
    LOCATIONS_DELETE: (id: number) => `/api/v1/locations/${id}`,
    
    // Radio channels endpoints
    RADIOCHANNELS: '/api/v1/radiochannels',
    RADIOCHANNELS_ADD: '/api/v1/radiochannels/add',
    RADIOCHANNELS_DELETE: (id: number) => `/api/v1/radiochannels/${id}`,
    
    // Feedback endpoints
    FEEDBACKS: '/api/v1/feedbacks',
    FEEDBACKS_ADD: '/api/v1/feedbacks/add',
    FEEDBACKS_DELETE: (id: number) => `/api/v1/feedbacks/${id}`,
    
    // Tasks endpoints
    TASKS: '/api/v1/tasks',
    TASKS_ADD: '/api/v1/tasks/add',
    TASKS_DELETE: '/api/v1/tasks/delete',
    
    // Team endpoints
    TEAMS: (opsID: number) => `/api/v1/teams/${opsID}`,
    TEAMS_CREATE: '/api/v1/teams',
    TEAMS_UPDATE: (id: number) => `/api/v1/teams/${id}`,
    TEAMS_DELETE: (id: number) => `/api/v1/teams/${id}`,
    TEAMS_MEMBERS: (teamID: number) => `/api/v1/teams/${teamID}/members`,
    TEAMS_MEMBERS_ADD: (teamID: number) => `/api/v1/teams/${teamID}/members`,
    TEAMS_MEMBERS_DELETE: (teamID: number, memberID: number) => `/api/v1/teams/${teamID}/members/${memberID}`,
    TEAMS_BY_ORG: '/api/v1/teams/by-org',
    TEAMS_BY_OPERATION: '/api/v1/teams/by-operation',
    
    // User endpoints
    USERS_ACTIVE: '/api/v1/users/active',
    USERS: '/api/v1/users',
    USERS_UPDATE: (userID: number) => `/api/v1/users/${userID}`,
    USERS_DELETE: (userID: number) => `/api/v1/users/${userID}`,
    
    // Role endpoints
    ROLES: '/api/v1/roles',
    ROLES_USERS: '/api/v1/roles/users',
    ROLES_PERMISSIONS: '/api/v1/roles/permissions',
    
    // Rank endpoints
    RANKS: '/api/v1/ranks',
    
    // Audit log endpoints
    AUDITLOG: (opsID: number) => `/api/v1/auditlog/${opsID}`,
    AUDITLOG_CREATE: '/api/v1/auditlog',
    

    
    // Geocoding endpoints
    GEOCODING_REVERSE: (lat: number, lon: number) => `/api/geocoding/reverse?lat=${lat}&lon=${lon}`,
  }
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${resolveApiBaseUrl()}${endpoint}`;
}; 